const getBaseUrl = () => {
  const apiUrl = process.env.REACT_APP_CONNECTORS_API_URL || '';
  // Strip trailing path segments to get base URL (e.g., "/v1/connectors" -> "")
  const idx = apiUrl.indexOf('/v1');
  return idx !== -1 ? apiUrl.substring(0, idx) : '';
};

const sendLog = (level, message, extra = {}) => {
  try {
    const baseUrl = getBaseUrl();
    const payload = {
      level,
      message: typeof message === 'string' ? message : JSON.stringify(message),
      url: window.location.href,
      userAgent: navigator.userAgent,
      ...extra,
    };

    // Fire-and-forget: do not await, do not block the app
    fetch(`${baseUrl}/v1/frontend-logs`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {
      // Silently ignore - logging must never break the app
    });
  } catch {
    // Silently ignore
  }
};

const logService = {
  info(message, extra) {
    console.log(message);
    sendLog('info', message, extra);
  },
  warn(message, extra) {
    console.warn(message);
    sendLog('warn', message, extra);
  },
  error(message, extra) {
    console.error(message);
    sendLog('error', message, extra);
  },
};

export default logService;
